import { FilterTypes } from '../models/FilterTypes';
import { FilterActionTypes, UpdateFilterAction } from './ActionTypes';

export function updateFilter(id: string, value: string, filterType: FilterTypes): UpdateFilterAction {
  return {
    type: FilterActionTypes.UPDATE_FILTER,
    id,
    value,
    filterType,
  };
}
